//import {Validar} from "../../validar-egresos";
import { endpoints } from "./endpoints";
import axios from "axios";

const BASEURL = process.env.VUE_APP_API_SERVEL;
const getAll = async (filters) => {
console.log('filters', filters);
    const url = `${BASEURL}${endpoints.egresos}`
    return axios.get(url,{params:filters}).then(response => { 
        return response.data.data;
    });
}

const send = async (data) => {

    try {

    const url = `${BASEURL}${endpoints.egresos}`
    return axios.post(url,{data:data}).then(response => { 
       return response.data;
    });
    } catch (error) {
        throw error
    }

}

export const EgresosService = {
    getAll,
    send
    // exportTeacherListExcel
}